import { Typography } from 'antd';
import rfsTheme from '../../theme';

const { Text } = Typography;

/**
 * Renders the Team Roster table's column title.
 */
const ColumnTitle = ({
  title,
  isToday,
  className,
  ...remaining
}: {
  readonly title: React.ReactElement;
  readonly isToday: boolean;
  readonly className: string;
  readonly remaining?: unknown;
}) => (
  <Text
    className={className}
    style={{ ...(isToday ? { color: rfsTheme.darkRfsRed } : {}) }}
    {...remaining}
  >
    {title}
  </Text>
);

export default ColumnTitle;
